import React from 'react';
import styled from 'styled-components';
import { ConditionalWrapper } from '../../utils';

export type BannerImageProps = {
  urlSm: string;
  urlMd: string;
  urlLg: string;
  href?: string;
  openInNewTab?: boolean;
  altText: string;
  hasBorderRadius?: boolean;
};

const Container = styled.div`
  display: flex;
  overflow: hidden;
  justify-content: center;
`;

const Image = styled.img<{ hasBorderRadius?: boolean }>`
  border-radius: ${({ hasBorderRadius }) => (hasBorderRadius ? '8px' : 0)};
`;

export const BannerImage: React.FC<BannerImageProps> = ({
  urlSm,
  urlLg,
  urlMd,
  href,
  openInNewTab = false,
  altText,
  hasBorderRadius = false,
}) => {
  return (
    <Container>
      <ConditionalWrapper
        condition={!!href}
        wrapper={(children: JSX.Element) => (
          <a
            href={href}
            target={openInNewTab ? '_blank' : '_self'}
            rel="noreferrer"
          >
            {children}
          </a>
        )}
        falseWrapper={(children: JSX.Element) => <div>{children}</div>}
      >
        <picture>
          <source media="(max-width: 576px)" srcSet={urlSm} />
          <source
            media="(min-width: 577px) and (max-width: 769px)"
            srcSet={urlMd}
          />
          <Image src={urlLg} alt={altText} hasBorderRadius={hasBorderRadius} />
        </picture>
      </ConditionalWrapper>
    </Container>
  );
};
